import { useInitData } from '../../../hooks'
import { BirdviewSkeletonLayout } from '../BirdviewSkeletonLayout'

import { useBirdviewDwellerWidgets } from './BirdviewDweller.hooks'
import { getBirdviewDwellerLayout } from './BirdviewDweller.utils'

function BirdviewDweller({ role, sections, storageScope, onNavigate }) {
  const { sections: sectionsPermissions } = useInitData()

  const { widgets, widgetTitles } = useBirdviewDwellerWidgets({
    sections,
    onNavigate,
  })

  return (
    <BirdviewSkeletonLayout
      defaultLayout={getBirdviewDwellerLayout(role, sectionsPermissions)}
      storageScope={storageScope}
      widgets={widgets}
      widgetTitles={widgetTitles}
      onNavigate={onNavigate}
    />
  )
}

export default BirdviewDweller
